module.exports = __webpack_public_path__ + "static/img/logo65.e523699.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo65.png
// module id = D7GU
// module chunks = 1